import styled from "styled-components";


export const Container = styled.div`

    .size-container{
        min-width:320px;
        border-radius:20px;
    }

    @media (max-width:768px){
        .size-container{
            height:auto !important;
            padding-bottom:20px !important;
        }
    }
`;

export const MainContainer = styled.div`

`;


export const InputsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2,1fr);
    width: 100%;
    padding: 0 30px;

    @media (max-width: 768px){
        display:flex;
        flex-direction:column;
    }
`;

export const ButtonContainer = styled.div`
    display:flex;
    widht:100%;
    justify-content:center;
    align-items:center;
`;


